import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import "../styles/admin.css";

const AdminNotice = () => {
  const [form, setForm] = useState({ title: "", content: "" });
  const [notices, setNotices] = useState([]);
  const [editId, setEditId] = useState(null);

  // LOAD DATA
  const fetchNotices = () => {
    fetch("https://kasiaweb.ilakshyaerp.in/api/notices")
      .then((res) => res.json())
      .then((data) => setNotices(data));
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  // ADD / UPDATE
  const handleSubmit = () => {
    const url = editId
      ? `https://kasiaweb.ilakshyaerp.in/api/notices/${editId}`
      : "https://kasiaweb.ilakshyaerp.in/api/notices/add";

    const method = editId ? "PUT" : "POST";

    fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    }).then(() => {
      setForm({ title: "", content: "" });
      setEditId(null);
      fetchNotices();
    });
  };

  // EDIT
  const handleEdit = (notice) => {
    setForm({ title: notice.title, content: notice.content });
    setEditId(notice.id);
  };

  // DELETE (SOFT)
  const handleDelete = (id) => {
    fetch(`https://kasiaweb.ilakshyaerp.in/api/notices/${id}`, {
      method: "DELETE",
    }).then(fetchNotices);
  };

  return (
    <AdminLayout>

      <div className="notice-page">

        {/* ================= FORM CARD ================= */}
        <div className="notice-card">

          <h2>{editId ? "Edit Notice" : "Add Notice"}</h2>

          <input
            placeholder="Enter Title"
            value={form.title}
            onChange={(e) =>
              setForm({ ...form, title: e.target.value })
            }
          />

          <textarea
            placeholder="Enter Content"
            value={form.content}
            onChange={(e) =>
              setForm({ ...form, content: e.target.value })
            }
          />

          <button onClick={handleSubmit}>
            {editId ? "Update Notice" : "Add Notice"}
          </button>

        </div>

        {/* ================= TABLE ================= */}
        <div className="notice-table">

          <h2>All Notices</h2>

          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Content</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {notices.map((n) => (
                <tr key={n.id}>
                  <td>{n.title}</td>
                  <td>{n.content}</td>
                  <td>

                    <button
                      className="edit-btn"
                      onClick={() => handleEdit(n)}
                    >
                      Edit
                    </button>

                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(n.id)}
                    >
                      Delete
                    </button>

                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

      </div>

    </AdminLayout>
  );
};

export default AdminNotice;